module.exports = __webpack_public_path__ + "static/media/r-project.fef47801.svg";